import { render, staticRenderFns } from "./onas.vue?vue&type=template&id=b87ded04&class=fl"
import script from "./onas.vue?vue&type=script&lang=js"
export * from "./onas.vue?vue&type=script&lang=js"
import style0 from "./onas.vue?vue&type=style&index=0&id=b87ded04&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports